<template>
  <label
    class="relative inline-flex cursor-pointer items-center"
    :class="{
      'mb-5': !showNewDesktopPlpQuickFilters,
    }"
  >
    <input
      type="checkbox"
      class="peer sr-only"
      :checked="modelValue"
      :aria-label="ariaLabel"
      @click.stop="toggle"
    />
    <div
      class="peer h-5 w-9 rounded-full border after:absolute after:left-1 after:top-1 after:size-3 after:rounded-full after:bg-black after:transition-all after:content-[''] peer-checked:after:translate-x-4 peer-checked:after:bg-green peer-focus:ring-2"
      :class="{
        'after:bg-black-40': isMuted,
      }"
    ></div>
  </label>
</template>

<script setup lang="ts">
type ToggleProps = {
  modelValue?: boolean
  isMuted?: boolean
  ariaLabel?: string
}

const props = withDefaults(defineProps<ToggleProps>(), {
  modelValue: false,
  isMuted: false,
  ariaLabel: undefined,
})

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()

const { showNewDesktopPlpQuickFilters } = useExperiments()
const toggle = () => emit('update:modelValue', !props.modelValue)
</script>
